import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: require('../pages/Main').default,
        children: [
            {
                path: '/',
                component: require('../pages/home').default
            },
            {
                path: '/index',
                component: require('../pages/index').default
            },
            {
                path: '/order',
                component: require('../pages/order').default
            }
        ]
      },
      {
          path: '/test',
          component: require('../pages/test').default
      },
    



    {
      path:'*',
      component: require('../pages/home').default
    }
]
export default new VueRouter({routes})